import axios from "axios";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// The Service page and the printer cards' ink: the backend's routes/api/service.js.
// Kept on the page, not in the store: each call returns the whole plan the backend
// sent, { today, marks, planDays, printers, days }, or null when it failed and the
// error was shown.

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch, quiet) => {
	// No response: the network or the server is down. The next refresh tries again.
	if (!err.response) {
		if (!quiet) toastr.error("Сервертэй холбогдож чадсангүй");
		return;
	}
	if (err.response.status === 401 && err.response.data.msg === "Token is not valid") {
		window.localStorage.clear("x-auth-token");
		toastr.error("Session expired");
		dispatch(logout());
	}
	const errors = err.response.data.errors;
	if (errors && !quiet) {
		errors.forEach((error) => toastr.error(error.msg));
	}
};

const config = {
	headers: {
		"Content-Type": "application/json",
	},
};

// A backend without these routes answers with the admin's index.html and a 200
const isPlan = (data) => Boolean(data) && Array.isArray(data.days) && Array.isArray(data.printers);

const call = async (dispatch, request, quiet = false) => {
	try {
		const res = await request();
		return isPlan(res.data) ? res.data : null;
	} catch (err) {
		handleError(err, dispatch, quiet);
		return null;
	}
};

// quiet: for the refresh of a page that does not need it, e.g. the printer cards
export const getService = (quiet = false) => (dispatch) =>
	call(dispatch, () => axios.get("/api/service"), quiet);

// { printerId, paper, black: { before, after }, color: { before, after } }
export const recordVisit = (visit) => (dispatch) =>
	call(dispatch, () => axios.post("/api/service/visits", JSON.stringify(visit), config));

// ordered: an admin's order, which needs service.assign, for todo: some of "paper",
// "black" and "color"
export const planKiosk = (printerId, day, ordered = false, todo = []) => (dispatch) =>
	call(dispatch, () =>
		axios.put("/api/service/plans/" + printerId, JSON.stringify({ day, ordered, todo }), config)
	);

export const unplanKiosk = (printerId) => (dispatch) =>
	call(dispatch, () => axios.delete("/api/service/plans/" + printerId));
